<div class="col-xs-12">
  <div class="panel" [id]="panelId" (click)="navigate()">
    <div>
      <div class="heading-big">{{ heading }}</div>
      <div>{{ description }}</div>
    </div>
  </div>
</div>
